var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99959 9.99609C6.99959 8.33921 8.34239 6.99593 9.99927 6.99593C11.6561 6.99593 12.9994 8.33921 12.9994 9.99609C12.9994 11.653 11.6561 12.9963 9.99927 12.9963C8.34239 12.9963 6.99959 11.6535 6.99959 9.99609ZM5.37788 9.99609C5.37788 12.5488 7.44703 14.6175 9.99976 14.6175C12.5525 14.6175 14.6216 12.5483 14.6216 9.99609C14.6216 7.44385 12.5525 5.37422 9.99976 5.37422C7.44703 5.37422 5.37788 7.44337 5.37788 9.99609ZM13.7238 5.19153C13.7238 5.78795 14.2074 6.27153 14.8038 6.27153C15.4002 6.27153 15.8838 5.78746 15.8838 5.19153C15.8838 4.59561 15.4002 4.11153 14.8038 4.11153C14.2074 4.11153 13.7238 4.59512 13.7238 5.19153ZM6.36263 17.3216C5.48535 17.2816 5.0086 17.1355 4.69159 17.0119C4.27102 16.8483 3.97159 16.6534 3.65652 16.3383C3.34146 16.0233 3.14657 15.7239 2.98293 15.3038C2.85984 14.9868 2.7133 14.51 2.67324 13.6327C2.62977 12.6836 2.62049 12.3989 2.62049 9.99609C2.62049 7.59332 2.62977 7.30855 2.67324 6.35897C2.7133 5.48168 2.85984 5.00494 2.98293 4.68793C3.14608 4.26784 3.34146 3.96793 3.65652 3.65286C3.97159 3.3378 4.27102 3.1429 4.69159 2.97976C5.0086 2.85666 5.48535 2.71012 6.36263 2.66958C7.31172 2.62611 7.5965 2.61731 9.99927 2.61731C12.402 2.61731 12.6868 2.6266 13.6364 2.66958C14.5137 2.70964 14.9904 2.85617 15.3074 2.97976C15.7275 3.1429 16.0274 3.3378 16.3425 3.65286C16.6576 3.96793 16.8525 4.26736 17.0156 4.68793C17.1387 5.00494 17.2852 5.48168 17.3258 6.35897C17.3693 7.30806 17.378 7.59284 17.378 9.99609C17.378 12.3993 17.3693 12.6836 17.3258 13.6327C17.2857 14.51 17.1392 14.9868 17.0156 15.3038C16.8525 15.7239 16.6576 16.0238 16.3425 16.3383C16.0274 16.6534 15.728 16.8483 15.3074 17.0119C14.9904 17.1355 14.5137 17.2816 13.6364 17.3216C12.6873 17.3651 12.4025 17.3744 9.99927 17.3744C7.59601 17.3744 7.31172 17.3656 6.36263 17.3216ZM6.28887 1.05031C5.33099 1.09379 4.67693 1.2457 4.10396 1.46844C3.51194 1.69851 3.01028 2.00624 2.51009 2.50643C2.00942 3.00711 1.70168 3.50877 1.4721 4.1003C1.24936 4.67278 1.09696 5.32684 1.05397 6.28521C1.01001 7.24505 0.999756 7.55132 0.999756 9.99609C0.999756 12.4409 1.01001 12.7466 1.05397 13.707C1.09745 14.6649 1.24936 15.3189 1.4721 15.8914C1.70168 16.4834 2.00942 16.9856 2.51009 17.4858C3.01028 17.9864 3.51194 18.2937 4.10396 18.5237C4.67644 18.7465 5.3305 18.8984 6.28887 18.9419C7.24871 18.9858 7.55498 18.9961 9.99927 18.9961C12.4436 18.9961 12.7503 18.9858 13.7101 18.9419C14.668 18.8984 15.3221 18.7465 15.8951 18.5237C16.4866 18.2937 16.9887 17.9859 17.4889 17.4858C17.9891 16.9856 18.2969 16.4834 18.5269 15.8914C18.7492 15.3189 18.9016 14.6649 18.945 13.707C18.989 12.7471 18.9993 12.4409 18.9993 9.99609C18.9993 7.55132 18.989 7.24505 18.945 6.28521C18.9016 5.32733 18.7492 4.67327 18.5269 4.1003C18.2969 3.50828 17.9891 3.00662 17.4889 2.50643C16.9887 2.00624 16.4866 1.69851 15.8951 1.46844C15.3226 1.2457 14.668 1.09379 13.7101 1.05031C12.7503 1.00635 12.444 0.996094 9.99927 0.996094C7.55449 0.996094 7.24871 1.00635 6.28887 1.05031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -43,
    y: -43,
    width: 106,
    height: 106
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4241 -42.3672H-42.3555V62.3611H62.4241V-42.3672Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17_162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -43,
    y: -43,
    width: 106,
    height: 106
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4285 -42.3789H-42.3511V62.3493H62.4285V-42.3789Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3772 -42.3789H-42.3511V62.3493H62.3772V-42.3789Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.7ff8534b3762c1051f9025e83bd72d5f.svg";
export { ForwardRef as ReactComponent };